var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("header", { staticClass: "header header--result" }, [
      _c("div", { staticClass: "header__container" }, [
        _c("div", { staticClass: "header__row" }, [
          _c("div", { staticClass: "logo" }, [
            _c("div", { staticClass: "logo__container" }, [
              _c("div", { staticClass: "logo__row" }, [
                _c("a", { attrs: { href: "/myprotein" } }, [
                  _c("h1", {
                    staticClass: "logo__logo",
                    class: { "logo__logo logo__logo--black": this.isPopup },
                    attrs: { "aria-label": "my Protein TEST" }
                  })
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "logo__trigger",
                  class: { "rotate-down": this.isPopup },
                  attrs: {
                    type: "button",
                    "aria-controls": "logoLayer",
                    "aria-label": "버튼",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.popup()
                    }
                  }
                }),
                _vm._v(" "),
                this.isPopup
                  ? _c(
                      "div",
                      {
                        staticClass: "logo__layer",
                        style: { display: this.isPopup ? "block" : "none" },
                        attrs: { role: "menu", id: "logoLayer" }
                      },
                      [
                        _c("a", {
                          attrs: { role: "menuitem", "aria-label": "Amway" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c(
        "div",
        { staticClass: "contents__contents contents__contents--result" },
        [
          _c("div", { staticClass: "contents__set" }, [
            _c("p", { staticClass: "title title--white" }, [
              _vm._v("당신의 단백질 지식 점수는?")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contents__card result" }, [
              _c("div", { staticClass: "result__point" }, [
                _c("div", { staticClass: "result__row" }, [
                  this.myProteinQuizScore > 0
                    ? _c("span", [
                        _vm._v(_vm._s(this.myProteinQuizScore) + "점")
                      ])
                    : _c("span", [_vm._v("0점")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc desc--secondary desc--medium" }, [
                  _vm._v(_vm._s(this.proteinQuizScoreText))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "button" }, [
                _c("div", { staticClass: "button__row" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button__item button__item--tertiary",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.answerResult }
                    },
                    [_vm._v("알쏭달쏭 단백질 퀴즈 정답 결과보기")]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contents__set" },
            [
              this.proteinSelfScore >= 10 && this.proteinSelfScore <= 30
                ? _c("myproteinSelfLowScore", {
                    attrs: {
                      proteinSelfScore: this.proteinSelfScore,
                      proteinSelfCheckList: this.userAnswer.self.Q9
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfScore >= 40 && this.proteinSelfScore <= 60
                ? _c("myproteinSelfMiddleScore", {
                    attrs: {
                      proteinSelfScore: this.proteinSelfScore,
                      proteinSelfCheckList: this.userAnswer.self.Q9
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfScore >= 70 && this.proteinSelfScore <= 100
                ? _c("myproteinSelfHighScore", {
                    attrs: {
                      proteinSelfScore: this.proteinSelfScore,
                      proteinSelfCheckList: this.userAnswer.self.Q9
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "contents__card" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "measure" }, [
                  _c("div", { staticClass: "measure__measure" }, [
                    _c("p", { staticClass: "measure__number" }, [
                      _vm._v(_vm._s(this.proteinPurposeScore) + "g")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "measure__bg",
                      attrs: { "aria-hidden": "true" }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "contents__msg contents__msg--secondary" },
                [
                  _vm._v(
                    "*출처:  Wu, Guoyao. “Dietary protein intake and human health.” Food & function 7.3 (2016): 1251-1265., Leidy, Heather J., et al. “The role of protein in weight loss and maintenance.” The American journal of clinical nutrition 101.6 (2015): 1320S-1329S., Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8."
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc desc--tertiary desc--bold" }, [
      _vm._v("\n\t\t\t\t\t\t\t내 몸이 필요로 하는"),
      _c("br"),
      _vm._v(" "),
      _c("em", [_vm._v("단백질 하루 권장 섭취량")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button button--inline" }, [
      _c("div", { staticClass: "button__row" }, [
        _c(
          "a",
          {
            staticClass: "button__item button__item--quaternary",
            attrs: { href: "/myprotein-detail" }
          },
          [
            _vm._v(
              "\n\t\t\t\t\t\t\t\t\t주요 식품별 단백질 함량 알아보기\n\t\t\t\t\t\t\t\t\t"
            ),
            _c("i")
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents__set" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("\n\t\t\t\t\t\t단백질,"),
        _c("br"),
        _vm._v("\n\t\t\t\t\t\t왜 먹어야 할까요?\n\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents__card" }, [
        _c("div", { staticClass: "protein-item" }, [
          _c("ul", { staticClass: "protein-item__list" }, [
            _c(
              "li",
              { staticClass: "protein-item__item protein-item__item--01" },
              [
                _c(
                  "a",
                  {
                    staticClass: "protein-item__row",
                    attrs: { href: "/myprotein-info01" }
                  },
                  [
                    _c("i"),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("우리 몸에서 수분 다음으로 많은 성분 ‘단백질’")
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "protein-item__arrow",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "protein-item__item protein-item__item--02" },
              [
                _c(
                  "a",
                  {
                    staticClass: "protein-item__row",
                    attrs: { href: "/myprotein-info02" }
                  },
                  [
                    _c("i"),
                    _vm._v(" "),
                    _c("p", [_vm._v("우리 몸 속 많은 역할을 하는 ‘단백질’")]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "protein-item__arrow",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "protein-item__item protein-item__item--03" },
              [
                _c(
                  "a",
                  {
                    staticClass: "protein-item__row",
                    attrs: { href: "/myprotein-info03" }
                  },
                  [
                    _c("i"),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("나이가 들수록 감소하는 체내 ‘단백질 양’")
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "protein-item__arrow",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents__set" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("\n\t\t\t\t\t\t올바른"),
        _c("br"),
        _vm._v("\n\t\t\t\t\t\t단백질 섭취 방법 4가지\n\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-swiper" }, [
        _c("div", { staticClass: "card-swiper__swiper swiper-container" }, [
          _c("div", { staticClass: "swiper-wrapper" }, [
            _c(
              "div",
              {
                staticClass:
                  "card-swiper__slide card-swiper__slide--first swiper-slide",
                staticStyle: { "background-color": "#DBDFE2" }
              },
              [
                _c("p", { staticClass: "card-swiper__header" }, [
                  _vm._v("첫번째")
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card-swiper__ico",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v("\n\t\t\t\t\t\t\t\t\t\t근육 증가를 위해서는 매일"),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "line-highlight" }, [
                    _vm._v("체중 1kg당 1.5g 단백질 섭취")
                  ]),
                  _vm._v(
                    "와 함께 주 3회 이상 근력 운동 수행을 필요로 합니다.\n\t\t\t\t\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-swiper__msg" }, [
                  _vm._v(
                    "*출처: Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8."
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-swiper__slide card-swiper__slide--second swiper-slide"
              },
              [
                _c("p", { staticClass: "card-swiper__header" }, [
                  _vm._v("두번째")
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card-swiper__ico",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v("\n\t\t\t\t\t\t\t\t\t\t단백질은 "),
                  _c("span", { staticClass: "line-highlight" }, [
                    _vm._v("3시간 이상")
                  ]),
                  _vm._v(
                    "의\n\t\t\t\t\t\t\t\t\t\t간격을 두고 균등하게 섭취합니다.\n\t\t\t\t\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-swiper__msg" }, [
                  _vm._v(
                    "*출처:  Moore, Daniel R., et al. “Daytime pattern of post-exercise protein intake affects whole-body protein turnover in resistance-trained males.” Nutrition & metabolism 9.1 (2012): 1-5."
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-swiper__slide card-swiper__slide--third swiper-slide",
                staticStyle: { "background-color": "#00D060" }
              },
              [
                _c("p", { staticClass: "card-swiper__header" }, [
                  _vm._v("세번째")
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card-swiper__ico",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v("\n\t\t\t\t\t\t\t\t\t\t하루에 최소 세번 이상 특히"),
                  _c("br"),
                  _vm._v("\n\t\t\t\t\t\t\t\t\t\t운동 후 "),
                  _c("span", { staticClass: "line-highlight" }, [
                    _vm._v("45분 이내")
                  ]),
                  _vm._v("의 골든타임을 지켜서 섭취합니다.\n\t\t\t\t\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-swiper__msg" }, [
                  _vm._v(
                    "*출처:  Ivy, J. L., & Ferguson-Stegall, L. M. (2013). Nutrient Timing. American Journal of Lifestyle Medicine, 8(4), 246-259."
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-swiper__slide card-swiper__slide--fourth swiper-slide"
              },
              [
                _c("p", { staticClass: "card-swiper__header" }, [
                  _vm._v("네번째")
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card-swiper__ico",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v("\n\t\t\t\t\t\t\t\t\t\t단백질의 대사와 합성을"),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "line-highlight" }, [
                    _vm._v("도와주는 비타민, 미네랄과 함께")
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t\t\t\t\t\t섭취합니다.\n\t\t\t\t\t\t\t\t\t"
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-pagination" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-prev" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-next" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents__set button" }, [
      _c("div", { staticClass: "button__row" }, [
        _c(
          "a",
          {
            staticClass: "button__item button__item--secondary",
            attrs: { href: "/myprotein" }
          },
          [_c("i"), _vm._v("\n\t\t\t\t\t\t\t다시 시작하기\n\t\t\t\t\t\t")]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e616cb2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e616cb2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinResult.vue
// module id = null
// module chunks = 